/**
 * Default settings for a map.
 */

let settings: Record<SettingsFields, any> = {
  enYuksekSeviye: 1,
  guncellemeKapali: true,
  koseler: [],
  matrix_olusturuldu: false,
  maximumSeviye: 20,
  sonQuadSeviyesi: 0,
  center: [0, 0],
};

type SettingsFields =
  | 'enYuksekSeviye'
  | 'guncellemeKapali'
  | 'koseler'
  | 'matrix_olusturuldu'
  | 'maximumSeviye'
  | 'sonQuadSeviyesi'
  | 'center';

export function setSetting(fieldName: SettingsFields, value: any) {
  try {
    settings[fieldName] = value;
    return 1;
  } catch (e) {
    return 0;
  }
}

export function setSettings(data: Record<SettingsFields, any>) {
  settings = data;
}

export function getSetting(fieldName: SettingsFields) {
  return settings[fieldName];
}

export function getSettings() {
  return settings;
}
